var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9514 11.0812L16.6741 6H15.7919L12.5595 10.4119L9.97773 6H7L10.9041 12.6716L7 18H7.88222L11.2958 13.3409L14.0223 18H17L12.9511 11.0812H12.9514ZM11.743 12.7304L11.3475 12.066L8.20009 6.77981H9.55512L12.0951 11.046L12.4907 11.7103L15.7923 17.2557H14.4373L11.743 12.7306V12.7304Z",
    fill: "#1D314C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.c9410095ae7efb32b5eadc6b05e0905c.svg";
export { ForwardRef as ReactComponent };